import DataTableRemotePaging from "./DataTableRemotePaging";
import DataTable from "./DataTable";

export default DataTableRemotePaging
export { DataTable }